import { createSelector } from 'reselect';
import {
  EMPTY_CLIENTI_SCOPE,
  EMPTY_STATISTICS_SCOPE,
  mapClientsToScope,
  mergeStatisticsScope,
} from '../containers/StatisticNew/apiMappers';

const selectStatisticState = (state) => state.statisticReducer || {};

export const getDashboard = () =>
  createSelector(selectStatisticState, (state) => state?.dashboard ?? null);

export const getStatisticsFinance = () =>
  createSelector(selectStatisticState, (state) => state?.finance ?? null);

export const getStatisticsBookings = () =>
  createSelector(selectStatisticState, (state) => state?.bookings ?? null);

export const getStatisticsQueue = () =>
  createSelector(selectStatisticState, (state) => state?.queue ?? null);

export const getClients = () =>
  createSelector(selectStatisticState, (state) => state?.clients ?? null);

export const getStatisticsScope = () =>
  createSelector(
    (state) => state.statisticReducer?.finance ?? null,
    (state) => state.statisticReducer?.bookings ?? null,
    (state) => state.statisticReducer?.queue ?? null,
    (finance, bookings, queue) =>
      mergeStatisticsScope(finance, bookings, queue) || EMPTY_STATISTICS_SCOPE,
  );

/** Scope filtrato per poltrona (filtro solo FE; i payload restano always-all). */
export const getStatisticsScopeForPoltrona = (poltronaId) =>
  createSelector(
    (state) => state.statisticReducer?.finance ?? null,
    (state) => state.statisticReducer?.bookings ?? null,
    (state) => state.statisticReducer?.queue ?? null,
    (finance, bookings, queue) =>
      mergeStatisticsScope(finance, bookings, queue, { poltronaId }) ||
      EMPTY_STATISTICS_SCOPE,
  );

export const getClientsScope = () =>
  createSelector(
    (state) => state.statisticReducer?.clients ?? null,
    (clients) => mapClientsToScope(clients) || EMPTY_CLIENTI_SCOPE,
  );

export const getClientsScopeForPoltrona = (poltronaId) =>
  createSelector(
    (state) => state.statisticReducer?.clients ?? null,
    (clients) => mapClientsToScope(clients, poltronaId) || EMPTY_CLIENTI_SCOPE,
  );

export const getStatisticsLoading = () =>
  createSelector(selectStatisticState, (state) => ({
    finance: Boolean(state?.loadingFinance),
    bookings: Boolean(state?.loadingBookings),
    queue: Boolean(state?.loadingQueue),
    clients: Boolean(state?.loadingClients),
    any: Boolean(
      state?.loadingFinance ||
        state?.loadingBookings ||
        state?.loadingQueue ||
        state?.loadingClients,
    ),
  }));

export const getStatisticsLockVersion = () =>
  createSelector(selectStatisticState, (state) => state?.lockVersion || 0);

export const getStatisticsUnlockedVersion = () =>
  createSelector(selectStatisticState, (state) => state?.unlockedVersion || 0);
